import React, { useState, useEffect } from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import Svg from '../Svg'
import { useSelector } from 'react-redux'
// import { setup, isSupported } from "@loomhq/record-sdk";
// import { oembed } from "@loomhq/loom-embed";

// const PUBLIC_APP_ID = "275541ce-5536-41c6-84e0-42f15d376302";
// const BUTTON_ID = "loom-record-sdk-button";

export default function SurveyListSidebar() {
    //States
    const [isVisibleSubmenu, setIsVisibleSubmenu] = useState(false)
    const { survey_id } = useSelector((state) => state.permissionsData)
    const { pathname } = useLocation()
    const [M1View, setM1View] = useState(0);
    const [M2View, setM2View] = useState(0);
    const [M3View, setM3View] = useState(0);
    const [M4View, setM4View] = useState(0);
    const [M5View, setM5View] = useState(0);
    const [M6View, setM6View] = useState(0);
    const [M7View, setM7View] = useState(0);
    const [M8View, setM8View] = useState(0);
    const [M9View, setM9View] = useState(0);
    const [M10View, setM10View] = useState(0);
    const [M11View, setM11View] = useState(0);
    const [M12View, setM12View] = useState(0);
    const [M13View, setM13View] = useState(0);
    const [M14View, setM14View] = useState(0);

    const { userData, userFlag } = useSelector((state) => state.userDataHeader)

    useEffect(() => {
        if (userFlag === true) {
            userData?.forEach(element => {
                let mp = JSON.parse(element.module_permissions)
                if (window.product === 'P1') {
                    window.modulePermissions.M1.view = (mp?.M1?.view === 1) ? 1 : window.modulePermissions.M1.view;
                    window.modulePermissions.M1.add = (mp?.M1?.add === 1) ? 1 : window.modulePermissions.M1.add;
                    window.modulePermissions.M1.edit = (mp?.M1?.edit === 1) ? 1 : window.modulePermissions.M1.edit;
                    window.modulePermissions.M1.del = (mp?.M1?.del === 1) ? 1 : window.modulePermissions.M1.del;
                    window.modulePermissions.M2.view = (mp?.M2?.view === 1) ? 1 : window.modulePermissions.M2.view;
                    window.modulePermissions.M3.view = (mp?.M3?.view === 1) ? 1 : window.modulePermissions.M3.view;
                    window.modulePermissions.M3.add = (mp?.M3?.add === 1) ? 1 : window.modulePermissions.M3.add;
                    window.modulePermissions.M3.edit = (mp?.M3?.edit === 1) ? 1 : window.modulePermissions.M3.edit;
                    window.modulePermissions.M3.del = (mp?.M3?.del === 1) ? 1 : window.modulePermissions.M3.del;
                    window.modulePermissions.M4.view = (mp?.M4?.view === 1) ? 1 : window.modulePermissions.M4.view;
                    window.modulePermissions.M4.add = (mp?.M4?.add === 1) ? 1 : window.modulePermissions.M4.add;
                    window.modulePermissions.M4.edit = (mp?.M4?.edit === 1) ? 1 : window.modulePermissions.M4.edit;
                    window.modulePermissions.M4.del = (mp?.M4?.del === 1) ? 1 : window.modulePermissions.M4.del;
                    window.modulePermissions.M5.view = (mp?.M5?.view === 1) ? 1 : window.modulePermissions.M5.view;
                    window.modulePermissions.M5.add = (mp?.M5?.add === 1) ? 1 : window.modulePermissions.M5.add;
                    window.modulePermissions.M5.edit = (mp?.M5?.edit === 1) ? 1 : window.modulePermissions.M5.edit;
                    window.modulePermissions.M5.del = (mp?.M5?.del === 1) ? 1 : window.modulePermissions.M5.del;
                    window.modulePermissions.M10.view = (mp?.M10?.view === 1) ? 1 : window.modulePermissions.M10.view;
                    window.modulePermissions.M10.edit = (mp?.M10?.edit === 1) ? 1 : window.modulePermissions.M10.edit;
                    window.modulePermissions.M10.add = (mp?.M10?.add === 1) ? 1 : window.modulePermissions.M10.add;
                    window.modulePermissions.M10.del = (mp?.M10?.del === 1) ? 1 : window.modulePermissions.M10.del;
                    setM1View(window.modulePermissions.M1.view)
                    setM2View(window.modulePermissions.M2.view)
                    setM3View(window.modulePermissions.M3.view)
                    setM4View(window.modulePermissions.M4.view)
                    setM5View(window.modulePermissions.M5.view)
                    setM10View(window.modulePermissions.M10.view)
                }

            });


        }
    }, [userFlag])

    //Effects
    useEffect(() => {
        if (survey_id) {
            setIsVisibleSubmenu(true)
        }
    }, [survey_id])

    // const [videoHTML, setVideoHTML] = useState("");

    // useEffect(() => {
    //     async function setupLoom() {
    //         const { supported, error } = await isSupported();

    //         if (!supported) {
    //             console.warn(`Error setting up Loom: ${error}`);
    //             return;
    //         }

    //         const button = document.getElementById(BUTTON_ID);

    //         if (!button) {
    //             return;
    //         }

    //         console.log(button);
    //         console.log(PUBLIC_APP_ID);

    //         const { configureButton } = await setup({
    //             publicAppId: PUBLIC_APP_ID,
    //         });

    //         const sdkButton = configureButton({ element: button });

    //         sdkButton.on("insert-click", async (video) => {
    //             const { html } = await oembed(video.sharedUrl, { width: 400 });
    //             setVideoHTML(html);
    //         });
    //     }

    //     setupLoom();
    // }, []);


    const [isSidebarClosed, setIsSidebarClosed] = useState(false);

    const toggleSidebar = () => {
        setIsSidebarClosed(!isSidebarClosed);
    };


    return (
        <>
            <div className={`dashboard-side-menu-wrapper d-flex flex-column align-items-stretch ${isSidebarClosed ? 'desktop-sidebar-closed' : ''}`}>
                <button className={`action-button-sidebar ${isSidebarClosed ? 'closed' : ''}`} onClick={toggleSidebar}>
                    <Svg name="menu-toggle" />
                </button>
                <nav className="dashboard-side-menu position-static">
                    <ul className='top-menu'>
                        {/* <li>
                            <NavLink className={({ isActive }) => (isActive ? "active" : 'null')} to="/admin/roi">
                                <Svg name="dashboard" />
                                <span className="nav-text">
                                    Dashboard
                                </span>
                            </NavLink>
                        </li> */}
                        {(M1View === 1 || M2View === 1) && (
                            <li className="nav-category">
                                <span className="category-name"></span>
                            </li>
                        )}
                        {M1View === 1 && (
                            <li className="has-subnav">
                                <div className="d-flex drop-wrap align-items-center"> {/*Add Class Active once menu is active*/}
                                    <NavLink className={({ isActive }) => ((isActive || pathname === '/admin/roi' || (survey_id && isVisibleSubmenu)) ? "active" : 'null')} to="/admin/roi">
                                        <Svg name="survey" />
                                        <span className="nav-text">
                                            Calculator
                                        </span>
                                    </NavLink>
                                    {survey_id && <button className={`${survey_id && isVisibleSubmenu ? 'drop-btn' : 'drop-btn collapsed'}`} type="button" aria-expanded="false" aria-controls="collapseMenu" onClick={() => setIsVisibleSubmenu(!isVisibleSubmenu)}>
                                        <svg width={24} height={26} viewBox="0 0 24 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M4.07992 15.9941L10.5999 9.31544C11.3699 8.5267 12.6299 8.5267 13.3999 9.31544L19.9199 15.9941" stroke="#0F2744" strokeWidth="1.5" strokeMiterlimit={10} strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </button>}
                                </div>
                                {/* <div className="d-flex drop-wrap align-items-center">
                                    <NavLink className={({ isActive }) => ((isActive || pathname === '/admin/survey/create/start' || (survey_id && isVisibleSubmenu)) ? "active" : 'null')} to="/admin/survey/list">
                                        <Svg name="survey" />
                                        <span className="nav-text">
                                            Assessments
                                        </span>
                                    </NavLink>
                                    {survey_id && <button className={`${survey_id && isVisibleSubmenu ? 'drop-btn' : 'drop-btn collapsed'}`} type="button" aria-expanded="false" aria-controls="collapseMenu" onClick={() => setIsVisibleSubmenu(!isVisibleSubmenu)}>
                                        <svg width={24} height={26} viewBox="0 0 24 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M4.07992 15.9941L10.5999 9.31544C11.3699 8.5267 12.6299 8.5267 13.3999 9.31544L19.9199 15.9941" stroke="#0F2744" strokeWidth="1.5" strokeMiterlimit={10} strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </button>}
                                </div> */}
                                <div className={`collapse ${survey_id && isVisibleSubmenu ? 'show' : ''}`} id="collapseMenu">
                                    <ul className={`subnav`}>
                                        <li>
                                            <NavLink className={({ isActive }) => (isActive ? "active" : 'null')} to={`/admin/survey/create/qa-builder?survey_id=${survey_id}`}>Questions</NavLink>
                                        </li>
                                        {/* <li>
                                        <NavLink className={({ isActive }) => (isActive ? "active" : 'null')} to={`/admin/survey/design?survey_id=${survey_id}`}>Design</NavLink>
                                    </li>
                                    <li>
                                        <NavLink className={({ isActive }) => (isActive ? "active" : 'null')} to={`/admin/survey/question-logic?survey_id=${survey_id}`}>Logic</NavLink>
                                    </li> */}
                                        <li>
                                            <NavLink className={({ isActive }) => (isActive ? "active" : 'null')} to={`/admin/survey/form-builder?survey_id=${survey_id}`}>Lead Form</NavLink>
                                        </li>
                                        <li>
                                            <NavLink className={({ isActive }) => ((isActive || pathname === '/admin/survey/report/templates') ? "active" : 'null')} to={`/admin/survey/report/builder?survey_id=${survey_id}`}>Reports</NavLink>
                                        </li>
                                        {/* <li>
                                        <NavLink className={({ isActive }) => (isActive ? "active" : 'null')} to={`/admin/survey/template/landing-page?survey_id=${survey_id}`}>Landing page</NavLink>
                                    </li>
                                    <li>
                                        <NavLink className={({ isActive }) => (isActive ? "active" : 'null')} to={`/admin/survey/template/thank-you?survey_id=${survey_id}`}>Thank you page</NavLink>
                                    </li>
                                    <li>
                                        <NavLink className={({ isActive }) => (isActive ? "active" : 'null')} to={`/admin/survey/create/language?survey_id=${survey_id}`}>Languages</NavLink>
                                    </li> */}
                                        <li>
                                            <NavLink className={({ isActive }) => (isActive ? "active" : 'null')} to={`/admin/survey/create/lead-gen-variables?survey_id=${survey_id}`}>Variables</NavLink>
                                        </li>
                                        {/* <li>
                                        <NavLink className={({ isActive }) => (isActive ? "active" : 'null')} to={`/admin/survey/create/configuration?survey_id=${survey_id}`}>Configurations</NavLink>
                                    </li>
                                    <li>
                                        <NavLink className={({ isActive }) => (isActive ? "active" : 'null')} target="_blank" to={`/admin/survey/preview?survey_id=${survey_id}`}>Preview</NavLink>
                                    </li> */}
                                        <li>
                                            <NavLink className={({ isActive }) => (isActive ? "active" : 'null')} to={`/admin/survey/share?survey_id=${survey_id}`}>Share URLs</NavLink>
                                        </li>

                                        <li>
                                            <NavLink to={`/admin/survey/create/stages?survey_id=${survey_id}`} className={({ isActive }) => (isActive ? "active" : 'null')}>
                                                Stages
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink to={`/admin/survey/widgets?survey_id=${survey_id}`} className={({ isActive }) => (isActive ? "active" : 'null')}>
                                                widgets
                                            </NavLink>
                                        </li>
                                    </ul>
                                </div>
                            </li>
                        )}
                        {/* {M2View === 1 && (
                            <li>
                                <NavLink className={({ isActive }) => (isActive ? "active" : 'null')} to="/admin/roi-analytics">
                                    <Svg name="analytics" />
                                    <span className="nav-text">
                                        Analytics
                                    </span>
                                </NavLink>
                            </li>
                        )} */}

                        {(M9View === 1) && (
                            <li class="nav-category">
                                <span class="category-name">Katch</span>
                            </li>
                        )}

                        {(M12View === 1) && (
                            <li>
                                <NavLink className={({ isActive }) => (isActive ? "active" : 'null')} to="/admin/3d-infographics">
                                    <Svg name="common-knowledge" />
                                    <span className="nav-text">
                                        3D Infographics
                                    </span>
                                </NavLink>
                            </li>
                        )}

                        {(M13View === 1) && (
                            <li>
                                <NavLink className={({ isActive }) => (isActive ? "active" : 'null')} to="/admin/2d-infographics">
                                    <Svg name="videos" />
                                    <span className="nav-text">
                                        2D Infographics
                                    </span>
                                </NavLink>
                            </li>
                        )}

                        {(M14View === 1) && (
                            <li>
                                <NavLink className={({ isActive }) => (isActive ? "active" : 'null')} to="/admin/frontend-portals">
                                    <Svg name="common-knowledge" />
                                    <span className="nav-text">
                                        Frontend portals
                                    </span>
                                </NavLink>
                            </li>
                        )}



                        {(M9View === 1) && (
                            <li>
                                <NavLink className={({ isActive }) => (isActive ? "active" : 'null')} to="/admin/videos/list">
                                    <Svg name="videos" />
                                    <span className="nav-text">
                                        Videos
                                    </span>
                                </NavLink>
                            </li>
                        )}

                        {(M6View === 1 || M7View === 1 || M8View === 1) && (
                            <li class="nav-category">
                                <span class="category-name">Emma</span>
                            </li>
                        )}

                        {(M6View === 1) && (
                            <li>
                                <NavLink className={({ isActive }) => (isActive ? "active" : 'null')} to="/admin/common-knowledge">
                                    <Svg name="common-knowledge" />
                                    <span className="nav-text">
                                        Knowledge hub
                                    </span>
                                </NavLink>
                            </li>
                        )}

                        {(M7View === 1) && (
                            <li>
                                <NavLink className={({ isActive }) => (isActive ? "active" : 'null')} to="/admin/prompts">
                                    <Svg name="prompts" />
                                    <span className="nav-text">
                                        Prompts
                                    </span>
                                </NavLink>
                            </li>
                        )}

                        {(M8View === 1) && (
                            <li>
                                <NavLink className={({ isActive }) => (isActive ? "active" : 'null')} to="/admin/assistants">
                                    <Svg name="assistants" />
                                    <span className="nav-text">
                                        AI Assistants
                                    </span>
                                </NavLink>
                            </li>

                        )}

                        {(M11View === 1) && (
                            <li>
                                <NavLink className={({ isActive }) => (isActive ? "active" : 'null')} to="/admin/workflow/add">
                                    <Svg name="common-knowledge" />
                                    <span className="nav-text">
                                        Workflows
                                    </span>
                                </NavLink>
                            </li>
                        )}

                        {(M3View === 1 || M4View === 1 || M5View === 1 || M10View === 1) && (
                            <li className="nav-category">
                                <span className="category-name">Settings</span>
                            </li>
                        )}
                        {(M3View === 1 || M4View === 1 || M5View === 1 || M10View === 1) && (
                            <>

                                {/* {(M10View === 1) && (
                                    <li>
                                        <NavLink className={({ isActive }) => (isActive ? "active" : 'null')} to="/admin/languages">
                                            <Svg name="icon-lang" />
                                            <span className="nav-text">
                                                Languages
                                            </span>
                                        </NavLink>
                                    </li>
                                )} */}
                                <li>
                                    <NavLink className={({ isActive }) => (isActive ? "active" : 'null')} to="/admin/settings/profile">
                                        <Svg name="settings" />
                                        <span className="nav-text">
                                            Settings
                                        </span>
                                    </NavLink>
                                </li>
                                {/* <li>
                                    <NavLink className={({ isActive }) => (isActive ? "active" : 'null')} to="/admin/settings/profile">
                                        <Svg name="help" />
                                        <span className="nav-text">
                                            Help Center
                                        </span>
                                    </NavLink>
                                </li> */}
                            </>
                        )}

                        {M2View === 1 && (
                            <li>
                                <NavLink className={({ isActive }) => (isActive ? "active" : 'null')} to="/admin/ducumentation/surveys/document-dashboard">
                                    <Svg name="survey" />
                                    <span className="nav-text">
                                        Documentation
                                    </span>
                                </NavLink>
                            </li>
                        )}

                        {/* <li>
                            <button
                                className="dropdown-item d-flex align-items-center menu-item"
                                type="button"
                                id={BUTTON_ID}
                            >
                                <Svg name="delete" />
                                <span
                                    className="nav-text"
                                >
                                    Record
                                </span>
                            </button>
                            <div dangerouslySetInnerHTML={{ __html: videoHTML }}></div>
                        </li> */}
                        {/* <li>
                            <NavLink className={({ isActive }) => (isActive ? "" : 'null')} to="">
                                <Svg name="help" />
                                <span className="nav-text">
                                    Help
                                </span>
                            </NavLink>
                        </li> */}
                    </ul>
                </nav>
            </div>
        </>
    )
}